export default {
	cartTabMenu: {
		label: "Warenkorb",
		emptyButton: "Leeren",
		emptyButtonTooltip: "Entfernt alle Artikel aus dem Warenkorb.",
	},
	cartTabMenuItem: {
		removeTooltip: "Entfernt den Artikel aus dem Warenkorb.",
	},
	cartPosition: {
		showParts: "Teile anzeigen",
	},
	cartPositionItem: {
		materialLabel: "Material:",
		articleIdLabel: "Blexonnummer:",
		certificateLabel: "Zertifikat:",
		revalidateButton: "Blexonisieren",
		quantityUnit: "{quantity} Stk.",
		quantityPlaceholder: "Stk.",
		removeTooltip:
			"Entfernt den Artikel aus dem Warenkorb. Entfernt den Artikel nicht aus Stücklisten.",
		addToSavedCartTooltip: "Position zur aktuellen Stückliste hinzufügen",
		loadError: "Artikel konnte nicht geladen werden.",
	},
	currentCart: {
		title: "Warenkorb",
		emptyButton: "Leeren",
		emptyButtonTooltip: "Entfernt alle Artikel aus dem Warenkorb.",
		createListButton: "Stückliste erstellen",
		createListButtonTooltip: "Aus dem Warenkorb eine Stückliste erstellen.",
		emptyCartText: "Der Warenkorb ist leer. Gehen Sie zu {link} um neue Artikel in den Warenkorb zu legen.",
		emptyCartLinkText: "'Artikel'",
		newCartDialog: {
			title: "Neue Stückliste",
			text: "Der Warenkorb wird als Stückliste unter folgendem Namen gespeichert:",
			nameLabel: "Name der neuen Stückliste",
			saveButtonTooltip: "Speichert den Warenkorb als Stückliste.",
		},
		nameExistsError: "Eine Stückliste mit diesem Namen existiert bereits.",
		messages: {
			cartSaved: "Stückliste wurde gespeichert.",
		},
	},
	savedCarts: {
		title: "Stücklisten",
		noCartsText:
			"Noch keine Stücklisten gespeichert. Legen Sie Teile in den Warenkorb, um aus dem Warenkorb eine neue Stückliste zu erstellen.",
		selectPlaceholder: "Liste auswählen...",
		itemTooltipQuantity: "Anzahl: {quantity}",
		deleteButton: "Löschen",
		deleteButtonTooltip: "Stückliste löschen.",
		quantityLabel: "Anzahl",
		quantityPlaceholder: "Stk.",
		addButtonTooltip:
			"Alle Artikel der Stückliste in den Warenkorb legen. Bei vorhandenen Artikeln wird die Menge erhöht.",
		addButtonMultiple: "{amount} x zum Warenkorb hinzufügen",
		addButtonSingle: "Zu Warenkorb hinzufügen",
		removeArticleTooltip: "Aus Stückliste entfernen",
		addArticleTooltip: "Zum Warenkorb hinzufügen",
		deleteDialog: {
			title: "Stückliste löschen",
			text: "Sind Sie sicher, dass Sie die Stückliste löschen wollen?",
			text2: "Die Artikel, welche in der Liste enthalten sind, werden nicht gelöscht.",
			confirmButton: "Löschen",
			confirmButtonTooltip: "Löscht die Stückliste endgültig.",
		},
		messages: {
			articlesAdded: "Artikel aus Stückliste wurden dem Warenkorb hinzugefügt.",
			articleAdded:
				"{quantity} Stück dem Warenkorb hinzugefügt. {oldQuantity} + {quantity} = {newQuantity}",
			articleRemoved: "Artikel wurde aus der Stückliste entfernt.",
			cartDeleted: "Stückliste wurde gelöscht.",
		},
	},
};
